import { Text } from "@/components/Text";

/** A titled block in the space page's side rail. */
export function RailBlock({
  title,
  action,
  children,
}: Readonly<{ title: string; action?: React.ReactNode; children: React.ReactNode }>) {
  return (
    <section aria-label={title} className="flex flex-col gap-2 py-4 first:pt-0">
      <div className="flex min-h-8 items-center justify-between">
        <Text as="h2" variant="eyebrow" tone="tertiary">
          {title}
        </Text>
        {action}
      </div>
      {children}
    </section>
  );
}
